module.exports = __webpack_public_path__ + "img/treatment.498cae5c.svg";